module.exports = __webpack_public_path__ + "images/charity1.69e04236.svg";